<template>
  <div id="app">
    <moa-mobile v-if="isMobile"/>
    <mtd-row v-else class="page-top-btutton-list moa-page-pc" >
      <mtd-col :span="24">
        <div class="main-container">
          <mtd-row class="logo-block">
            <mtd-col :offset="4" :span="2">
              <img alt="logo" height="30px" src="@/assets/en/MOA_logo.png" style="margin-top: 13px" />
            </mtd-col>
            <mtd-col :offset="10" :span="8" style="height: 48px;">
              <a href="https://agent-repair-prompt.sankuai.com/#/templateHtml?index=9-1-1" style="text-decoration: none" target="_blank">
                <span class="help_concat" style="font-weight: 400; font-size: 14px; line-height: 48px">Help documentation</span>
              </a>
              <mtd-popover trigger="hover" placement="bottom-start" style="padding-left: 50px">
                <span class="help_concat">Contact us</span>
                <div slot="content" style="width: 204px; height: 265px; border-radius: 10px;">
                  <div v-if="isLogin">
                    <div
                      style="font-family: PingFangSC-Regular; font-size: 12px; line-height: 16px; font-weight: 400; padding-top: 16px; padding-left: 16px; color: #000000;"
                    >
                      Email address:
                    </div>
                    <div
                      style="font-family: PingFangSC-Regular; font-size: 12px; line-height: 16px; font-weight: 400; padding-top: 2px; padding-left: 16px; color: #000000; opacity: 0.6;"
                    >
                      moa.support@meituan.com
                    </div>
                    <div style="padding-top: 8px;"></div>
                    <div style="opacity: 0.15; border: 1px solid #979797; border-top: none"></div>
                    <div style="padding-top: 7.5px;"></div>
                    <a href="https://x.sankuai.com/chat/137977143912?type=pubchat" style="text-decoration: none" target="_blank">
                      <div
                        style="font-family: PingFangSC-Regular; font-size: 12px; line-height: 16px; font-weight: 400; padding-left: 16px;"
                        class="help_concat"
                      >
                        Employee help desk
                      </div>
                    </a>
                    <div style="padding-top: 7.5px;"></div>
                    <div style="opacity: 0.15; border: 1px solid #979797; border-top: none"></div>
                    <div
                      style="font-family: PingFangSC-Regular; font-size: 12px; line-height: 26px; font-weight: 400; padding-top: 7.5px; padding-left: 16px; color: #000000;"
                    >
                      Group feedback
                    </div>
                    <mtd-row style="height: 91px">
                      <mtd-col style="margin-top: 6px" :span="24">
                        <img style="margin-left: 16px" height="22px" width="62px" src="@/assets/img_moa问题反馈.png" />
                      </mtd-col>
                      <mtd-col :span="24">
                        <img style="margin-left: 16px; margin-top: 1px;" width="62px" height="62px" src="@/assets/img_moa问题反馈_2.jpeg" />
                      </mtd-col>
                    </mtd-row>
                  </div>
                  <div
                    v-else
                    style="width: 204px; height: 135px; font-family: PingFangSC-Regular; font-size: 10px; color: #166FF7; font-weight: 400; line-height: 14px; padding-top: 130px;"
                    align="middle"
                  >
                    <mtd-button type="text-primary" @click="login()" size="small">Click to log in</mtd-button>
                  </div>
                </div>
              </mtd-popover>
              <img
                v-if="isLogin"
                :src="login_user.avatar"
                style="border-radius: 50%; width: 24px; height: 24px; vertical-align: middle; margin-left: 48px;"
              />
              <mtd-popover v-if="isLogin" trigger="hover" placement="bottom" style="padding-left: 8px;">
                <span class="help_concat">{{ login_user.username }}</span>
                <div slot="content" style="width: 80px; height: 48px; border-radius: 10px;">
                  <mtd-button type="text" style="margin-top: 9px; font-size: 13px; margin-left: 3px;" @click="logout()">Log out</mtd-button>
                </div>
              </mtd-popover>
              <div v-if="!isLogin" style="display: inline-block;">
                <mtd-button type="primary" size="small" style="margin-left: 48px" @click="login()">Log in</mtd-button>
              </div>
              <div style="display: inline-block; margin-left: 30px; vertical-align: middle; padding-bottom: 6px;">
                <i class="mtdicon-globe" style="color: #1890ff; position: relative; top: 3px; display: inline-block; font-size: 18px; margin-right: 2px;"></i>
                <mtd-picker placeholder="请选择" v-model="language" @change="changeLanguage()" >
                  <mtd-option value="中文">中文</mtd-option>
                  <mtd-option value="English">English</mtd-option>
                  <mtd-option value="Português">Português</mtd-option>
                  <mtd-option value="العربية">العربية</mtd-option>
                </mtd-picker>
              </div>
            </mtd-col>
          </mtd-row>
          <mtd-row id="firstPage" class="page-top-background" style="height: calc(100vh - 48px); min-height: 700px">
            <mtd-col :span="24">
              <div class="center">
                <div class="scroll">
                  <i class="iconfont icon20_icon_Scrolldown">
                    <a href="/#banner" class="mtd-anchor-link-title">
                      <img
                        height="20px"
                        width="20px"
                        src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/ic_arrow.png"
                      /> </a
                    ></i>
                </div>
                <mtd-row class="text-image-block" justify="space-around" align="middle">
                  <mtd-col :span="24" class="text-block">
                    <div class="title" style="text-align: center; margin-top: 143px; font-size: 48px;">MOA Office security Agent</div>
                  </mtd-col>
                  <mtd-col :span="24">
                    <div
                      class="sub-title"
                      style="text-align: center; margin-top: 16px; font-size: 24px; color: #7E7E7E; font-weight: 500; line-height: 32px"
                    >
                      For users within the Keeta ecosystem, we maintain terminal security from multiple perspectives
                    </div>
                  </mtd-col>
                  <mtd-col :span="24">
                    <div class="sub-title" style="text-align: center; font-size: 24px; color: #7E7E7E; font-weight: 500; line-height: 32px">
                      enable intranet access control
                    </div>
                  </mtd-col>
                  <mtd-col :span="24" align="middle" style="margin-top: 46px;">
                    <div style="display: inline-block; width: 216px;vertical-align: top;">
                      <mtd-card
                        style="height: 116px; width: 116px; border-radius: 10px !important; box-shadow: 0 8px 24px 0 rgba(0,0,0,0.12);"
                        @mouseenter.native="winFlag1 = false"
                        @mouseleave.native="winFlag1 = true"
                      >
                        <div v-if="winFlag1 === true">
                          <img
                            height="44px"
                            width="44px"
                            src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/img_windows.png"
                            style="margin-top: 16px;"
                          />
                        </div>
                        <div v-else>
                          <div v-if="isLogin === true" @click="downloadWinFile">
                            <img
                              height="32"
                              width="32"
                              src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/download.png"
                              style="margin-top: 22px;"
                            />
                          </div>
                          <div
                            v-else
                            style="font-family: PingFangSC-Regular; font-size: 12px; color: #166FF7; font-weight: 400; line-height: 17px; margin-top: 30px"
                          >
                            <mtd-button type="text-primary" @click="login()" size="small">Click to log in</mtd-button>
                          </div>
                        </div>
                      </mtd-card>
                      <div style="margin-top: 20px;">
                        <span v-if="winFlag1 === true" style="font-family: PingFangSC-Regular; font-size: 14px; font-weight: 400;"
                        >Download for Windows</span
                        >
                        <span v-else style="font-family: PingFangSC-Regular; font-size: 14px; font-weight: 400;">Download</span>
                        <div class="version-tag">Support system {{ winOsVersion }}</div>
                      </div>
                    </div>
                    <div style="display: inline-block; width: 216px;vertical-align: top;">
                      <mtd-card
                        style="height: 116px; width: 116px; border-radius: 10px !important; box-shadow: 0 8px 24px 0 rgba(0,0,0,0.12);"
                        @mouseenter.native="macFlag1 = false"
                        @mouseleave.native="macFlag1 = true"
                      >
                        <div v-if="macFlag1 === true">
                          <img
                            height="44px"
                            width="44px"
                            src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/img_macOS.png"
                            style="margin-top: 16px"
                          />
                        </div>
                        <div v-else>
                          <div v-if="isLogin === true" @click="showMacDownloadModal">
                            <img
                              height="32"
                              width="32"
                              src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/download.png"
                              style="margin-top: 22px;"
                            />
                          </div>
                          <div
                            v-else
                            style="font-family: PingFangSC-Regular; font-size: 12px; color: #166FF7; font-weight: 400; line-height: 17px; margin-top: 30px"
                          >
                            <mtd-button type="text-primary" @click="login()" size="small">Click to log in</mtd-button>
                          </div>
                        </div>
                      </mtd-card>
                      <div style="margin-top: 20px;">
                        <div v-if="macFlag1 === true" style="font-family: PingFangSC-Regular; font-size: 14px; font-weight: 400;">
                          Download for MacOS
                        </div>
                        <div v-else style="font-family: PingFangSC-Regular; font-size: 14px; font-weight: 400;">Download</div>
                        <div class="version-tag">Support system {{ macOsVersion }}</div>
                      </div>
                    </div>
                  </mtd-col>
                </mtd-row>
              </div>
            </mtd-col>
          </mtd-row>
          <mtd-row id="banner" class="page-background-2" style="height: 320px;">
            <mtd-col :span="24" align="middle" style="margin-top: 120px;">
              <div
                style="text-align: center; color: #FFFFFF; font-size: 32px; font-family: PingFangSC-Semibold; font-weight: 600; line-height: 48px;"
              >
                MOA is your office toolbox, fortified with enterprise-grade security
              </div>
            </mtd-col>
            <mtd-col :span="24" align="middle" style="margin-top: 8px;">
              <div style="text-align: center; color: #FFFFFF; font-size: 16px; font-family: PingFangSC-Light; font-weight: 600; line-height: 24px;">
                Enterprise IT services + security services, brings you better secure office experience
              </div>
            </mtd-col>
          </mtd-row>
          <mtd-row style="height: 400px;">
            <mtd-col class="page-background-3" :offset="5" :span="7">
              <div
                style="margin-top: 173px;font-family: PingFangSC-Semibold; font-size: 24px; color: rgba(0,0,0,0.84); font-weight: 600; line-height: 33px;"
              >
                Security Baseline Scan
              </div>
              <div
                style="margin-top: 10px;font-family: PingFangSC-Semibold; font-size: 20px; color: rgba(0,0,0,0.84); font-weight: 600; line-height: 28px;"
              >
                Keep every endpoint compliant and secure — continuously
              </div>
            </mtd-col>
            <mtd-col :span="10">
              <img height="280px" width="524px" src="@/assets/img_01_2.png" style="margin-top: 61px" />
            </mtd-col>
          </mtd-row>
          <mtd-row style="height: 350px; background: #F4F8FF;">
            <mtd-col :offset="5" :span="7">
              <img height="304px" width="428px" src="@/assets/en/img_02.png" style="margin-top: 23px" />
            </mtd-col>
            <mtd-col class="page-background-4" :offset="1" :span="9">
              <div
                style="margin-top: 134px;font-family: PingFangSC-Semibold; font-size: 24px; color: rgba(0,0,0,0.84); font-weight: 600; line-height: 33px;"
              >
                Internal Network Access Control
              </div>
              <div
                style="margin-top: 10px;font-family: PingFangSC-Semibold; font-size: 20px; color: rgba(0,0,0,0.84); font-weight: 600; line-height: 28px;"
              >
                Authenticate trusted devices, grant secure access, and protect your internal network
              </div>
            </mtd-col>
          </mtd-row>
          <mtd-row style="height: 420px;">
            <mtd-col class="page-background-5" :offset="5" :span="7">
              <div
                style="margin-top: 173px;font-family: PingFangSC-Semibold; font-size: 24px; color: rgba(0,0,0,0.84); font-weight: 600; line-height: 33px;"
              >
                Vulnerability Patching
              </div>
              <div
                style="margin-top: 10px;font-family: PingFangSC-Semibold; font-size: 20px; color: rgba(0,0,0,0.84); font-weight: 600; line-height: 28px;"
              >
                Timely patching hardens every endpoint against attacks
              </div>
            </mtd-col>
            <mtd-col :span="10">
              <img height="280px" width="524px" src="@/assets/img_03_2.png" style="margin-top: 61px" />
            </mtd-col>
          </mtd-row>
          <mtd-row class="page-background-6" style="height: 270px;">
            <mtd-col :span="24" align="middle">
              <div style="margin-top: 41px;font-family: PingFangSC-Semibold; font-size: 32px; color: #000000; font-weight: 600; line-height: 45px;">
                MOA Office security Agent
              </div>
              <div
                style="margin-top: 12px;font-family: PingFangSC-Regular; font-size: 16px; color: #000000; font-weight: 400; line-height: 24px; opacity: 0.6;"
              >
                Enabling secure, seamless work from anywhere
              </div>
            </mtd-col>
            <mtd-col :span="24">
              <mtd-row type="flex" justify="space-around">
                <mtd-col :span="4"> </mtd-col>
                <mtd-col :span="3" align="middle" style="margin-top: 16px;">
                  <mtd-popover trigger="hover" placement="top">
                    <img
                      class="bottom_icon"
                      height="50px"
                      width="50px"
                      src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/img_windows.png"
                    />
                    <div slot="content" style="width: 80px; height: 80px; border-radius: 10px;">
                      <div v-if="isLogin === true" align="center" @click="downloadWinFile" style="cursor: pointer;">
                        <img
                          height="32"
                          width="32"
                          src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/download.png"
                          style="margin-top: 24px;"
                        />
                      </div>
                      <div
                        v-else
                        style="font-family: PingFangSC-Regular; font-size: 12px; color: #166FF7; font-weight: 400; line-height: 17px; text-align: center; padding-top: 31px"
                      >
                        <mtd-button type="text-primary" @click="login()" size="small">Click to log in</mtd-button>
                      </div>
                    </div>
                  </mtd-popover>
                  <div style=" height: 12px;">
                    <span style="font-family: PingFangSC-Regular; font-size: 12px; font-weight: 400;">Download for Windows</span>
                  </div>
                </mtd-col>
                <mtd-col :span="3" align="middle" style="margin-top: 16px;">
                  <mtd-popover trigger="hover" placement="top">
                    <img
                      class="bottom_icon"
                      height="50px"
                      width="50px"
                      src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/img_macOS.png"
                    />
                    <div slot="content" style="width: 80px; height: 80px; border-radius: 10px;">
                      <div v-if="isLogin === true" align="center" @click="showMacDownloadModal" style="cursor: pointer;">
                        <img
                          height="32"
                          width="32"
                          src="https://s3-fra01-eu.mykeeta.net/moa-download-ui/download.png"
                          style="margin-top: 24px;"
                        />
                      </div>
                      <div
                        v-else
                        style="font-family: PingFangSC-Regular; font-size: 12px; color: #166FF7; font-weight: 400; line-height: 17px; text-align: center; padding-top: 31px"
                      >
                        <mtd-button type="text-primary" @click="login()" size="small">Click to log in</mtd-button>
                      </div>
                    </div>
                  </mtd-popover>
                  <div style="margin-top: 5px;">
                    <div style="font-family: PingFangSC-Regular; font-size: 12px; font-weight: 400;">Download for MacOS</div>
                  </div>
                </mtd-col>
                <mtd-col :span="4"> </mtd-col>
              </mtd-row>
            </mtd-col>
            <mtd-modal class="page-background-8-en" title="" v-model="macFlag3" width="800px">
              <mtd-row style="height: 100px; top:420px">
                <mtd-col :offset="4" :span="6">
                  <mtd-button type="primary" size="large" round @click="downloadMacAppleFile">Download for Apple Silicon</mtd-button>
                </mtd-col>
                <mtd-col :offset="4" :span="6">
                  <mtd-button type="primary" size="large" round @click="downloadMacIntelFile">Download for Intel </mtd-button>
                </mtd-col>
              </mtd-row>
            </mtd-modal>
          </mtd-row>
          <mtd-row style="height: 112px; background: #303640">
            <mtd-col :offset="4" :span="4" style="margin-top: 30px">
              <img height="23px" width="126px" src="@/assets/en/MOA_logo_2.png" />
            </mtd-col>
            <mtd-col class="info-list-box" :offset="4" :span="8" style="margin-top: 30px">
              <div class="info-list">
                <div style="font-family: PingFangSC-Regular; font-size: 12px; color: #FFFFFF; line-height: 17px;">Contact us</div>
                <div style="font-family: PingFangSC-Regular; font-size: 12px; color: #FFFFFF; line-height: 17px; opacity: 0.5; margin-top: 10px;">
                  moa.support@meituan.com
                </div>
              </div>
              <div class="info-list">
                <a href="https://x.sankuai.com/chat/137977143912?type=pubchat" style="text-decoration: none" target="_blank">
                  <div style="font-family: PingFangSC-Regular; font-size: 12px; line-height: 17px; opacity: 0.5;" class="bottom_text">Employee help desk</div>
                </a>
              </div>
              <div class="info-list">
                <mtd-popover trigger="hover" placement="top">
                  <div style="font-family: PingFangSC-Regular; font-size: 12px; line-height: 17px; opacity: 0.5;" class="bottom_text">Group feedback</div>
                  <div slot="content" style="width: 180px; height: 120px; border-radius: 2px;">
                    <div v-if="isLogin === true">
                      <mtd-row>
                        <mtd-col :span="24" align="center" style="margin-top: 12px">
                          <img height="21px" width="62px" src="@/assets/img_moa问题反馈.png" />
                        </mtd-col>
                        <mtd-col :span="24" align="center" style="margin-top: 8px">
                          <img height="62px" width="62px" src="@/assets/img_moa问题反馈_2.jpeg" />
                        </mtd-col>
                      </mtd-row>
                    </div>
                    <div
                      v-else
                      style="font-family: PingFangSC-Regular; font-size: 10px; color: #166FF7; font-weight: 400; line-height: 14px; padding-top: 55px;"
                      align="middle"
                    >
                      <mtd-button type="text-primary" @click="login()" size="small">Click to log in</mtd-button>
                    </div>
                  </div>
                </mtd-popover>
              </div>
            </mtd-col>
          </mtd-row>
          <mtd-row style="height: 32px; background: rgb(59, 63, 72);">
            <mtd-col :span="24" style="margin-top: 7px" align="middle">
              <div style="font-family: PingFangSC-Regular; opacity: 0.2; font-size: 12px; color: #FFFFFF; font-weight: 400; line-height: 17px;">
                MOA is maintained by Information Security Department
              </div>
            </mtd-col>
          </mtd-row>
        </div>
      </mtd-col>
    </mtd-row>
  </div>
</template>
<script>
import sso from '@/utils/sso';
// import store from './store/index';
import {mapActions} from 'vuex';
import MoaMobile from './mobile.vue'

export default {
  name: "home-en.vue",
  components: {
    MoaMobile
  },
  data() {
    return {
      winFlag1: true,
      macFlag1: true,
      iosFlag1: true,
      androidFlag1: true,
      linuxFlag1: true,
      winFlag2: true,
      macFlag2: true,
      iosFlag2: true,
      androidFlag2: true,
      linuxFlag2: true,
      arrowHeight: 'calc(100vh - 700px)',
      isMobile: false,
      winOsVersion: 'Windows7 sp1(x64)/10/11',
      macOsVersion: 'macOS 13.5-26.0',
      iosOsVersion: 'iOS 11-17',
      androidOsVersion: 'Android 5-14',
      linuxOsVersion: 'Ubuntu 18/20',
      macFlag3: false,
      language: 'English'
    };
  },
  methods: {
    ...mapActions(['api_get_MacFile', 'api_get_WinFile', 'api_get_LinuxFile', 'api_get_os_version', 'api_get_MacIntelFile',
      'api_get_MacAppleFile']),
    login() {
      this.$router.push('/login');
    },
    logout() {
      sso.logout();
    },
    downloadWinFile() {
      if (this.isLogin === false) {
        return;
      }
      this.$mtd.message({
        message: '下载将在几秒钟内开始',
        type: 'info',
        duration: '7000',
      });
      this.api_get_WinFile().then(res => {
          window.location.href = res.data;
        }
      );
    },
    changeLanguage() {
      if (this.language === '中文') {
        this.$router.push('/home');
      } else if (this.language === 'English') {
        // 路由到home-en.vue
        this.$router.push('/home-en');
      } else if (this.language === 'Português') {
        this.$router.push('/home-br');
      } else if (this.language === 'العربية') {
        this.$router.push('/home-sa');
      }
    },
    downloadMacFile() {
      if (this.isLogin === true) {
        this.$mtd.message({
          message: '下载将在几秒钟内开始',
          type: 'info',
          duration: '7000',
        });
        this.api_get_MacFile().then(res => {
            window.location.href = res.data;
          }
        );
      }
    },
    downloadLinuxFile() {
      if (this.isLogin === true) {
        this.$mtd.message({
          message: '下载将在几秒钟内开始',
          type: 'info',
          duration: '7000',
        });
        this.api_get_LinuxFile().then(res => {
            window.location.href = res.data;
          }
        );
      }
    },
    getTarget() {
      return document.querySelector('#firstPage');
    },
    getOsVersion() {
      this.api_get_os_version().then(res => {
        if (res.code === 0) {
          const osVersion = JSON.parse(res.data);
          this.winOsVersion = osVersion.winOsVersion || 'Windows7 sp1(x64)/10/11';
          this.macOsVersion = osVersion.macOsVersion || 'macOS 13.5-26.0';
          this.iosOsVersion = osVersion.iosOsVersion || 'iOS 11-17';
          this.androidOsVersion = osVersion.androidOsVersion || 'Android 5-14';
          this.linuxOsVersion = osVersion.linuxOsVersion || 'Ubuntu 18/20';
        }
      })
    },
    showMacDownloadModal() {
      this.macFlag3 = true;
    },
    downloadMacAppleFile() {
      if (this.isLogin === true) {
        this.$mtd.message({
          message: '下载将在几秒钟内开始',
          type: 'info',
          duration: '7000',
        });
        this.api_get_MacAppleFile().then(res => {
            window.location.href = res.data;
          }
        );
      }
    },
    downloadMacIntelFile() {
      if (this.isLogin === true) {
        this.$mtd.message({
          message: '下载将在几秒钟内开始',
          type: 'info',
          duration: '7000',
        });
        this.api_get_MacIntelFile().then(res => {
            window.location.href = res.data;
          }
        );
      }
    }
  },
  mounted() {
    // const ua = navigator.userAgent.toLowerCase();
    // if (/mobile|android|iphone|ipad|phone/i.test(ua)) {
    //   this.isMobile = true;
    // }
    this.getOsVersion();
  },
  computed: {
    isLogin() {
      return this.$store.getters.get_login_user.mis_id ? true : false;
    },
    login_user() {
      return this.$store.getters.get_login_user;
    },
    getIosCodeUrl() {
      return this.$store.getters.get_ios_code;
    },
    getAndroidCodeUrl() {
      return this.$store.getters.get_android_code;
    },
  },
};
</script>

<style>
#app section {
  overflow: hidden;
}

#app section .mtd-main::-webkit-scrollbar {
  width: 0 !important;
}

#app section .mtd-main {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}

.image-block {
  display: block;
  width: 100%;
}

.logo-block {
  height: 48px;
}

.page-top-background {
  height: calc(100vh - 700px);
  min-height: 650px;
  width: 100%;
  position: absolute;
  z-index: 10;
}

.page-top-background .center {
  float: left;
  height: calc(100vh - 48px);
  min-height: 700px;
  display: inline-block;
}

.page-top-background .center {
  width: 100%;
  background: url(~@/assets/bg1.png) no-repeat;
  background-size: 100% 100%;
  background-position: center top;
}

.page-background-2 {
  height: 621px;
  width: 100%;
  position: absolute;
  z-index: 10;
  background: url(~@/assets/bg2.png) no-repeat;
  background-size: 100% auto;
}

.page-background-3 {
  background: url(~@/assets/img_01.png) no-repeat;
  background-position: 0% 64%;
  background-size: 102px 74px;
}

.page-background-4 {
  background: url(~@/assets/img_02_2.png) no-repeat;
  background-position: 0% 56%;
  background-size: 102px 74px;
}

.page-background-5 {
  background: url(~@/assets/img_03.png) no-repeat;
  background-position: 0% 64%;
  background-size: 102px 74px;
}

.page-background-6 {
  background: url(~@/assets/bg3.png) no-repeat;
  background-position: 0% 0%;
  background-size: 100% auto;
}

.page-background-8-en .mtd-modal {
  background: url(~@/assets/en/img_mac_download.png) no-repeat;
  background-position: 0% 0%;
  background-size: 800px auto;
  background-color: #f0f0f0 !important;
  height: 560px;
}

.card-icon {
  width: 100%;
  background: url(https://s3-fra01-eu.mykeeta.net/moa-download-ui/qrcode.png) no-repeat;
  background-size: 44px 44px;
  background-position: 98% 0%;
}

.page-top-btutton-list .main-container .text-image-block {
  margin-top: 60px;
  height: calc(100% - 108px);
}

.page-top-btutton-list .main-container .text-image-block .mtd-col-12 {
  height: 100%;
}

.page-top-btutton-list .main-container .text-image-block .text-block .title {
  font-family: meituantype-Regular;
  font-size: 40px;
  color: #000000;
  letter-spacing: 2.78px;
  font-weight: 400;
  line-height: 56px;
}

.page-top-btutton-list .main-container .text-image-block .text-block .sub-title {
  margin-top: 16px;
  width: 584px;
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #000000;
  letter-spacing: 0.89px;
  line-height: 56px;
  font-weight: 400;
}

.page-top-btutton-list .main-container .text-image-block .text-block .download-btns {
  margin-top: 92px;
}

.page-top-btutton-list .main-container .text-image-block .text-block .whitelist {
  margin-top: 40px;
}

.page-top-btutton-list .main-container .text-image-block .text-block .whitelist .whitelist-btn {
  width: 160px;
  height: 40px;
  padding: 0;
  text-align: left;
}

.page-top-btutton-list .main-container .text-image-block .text-block .whitelist .whitelist-btn span.text {
  font-family: PingFang SC;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  font-weight: 400;
}

.page-top-btutton-list .main-container .text-image-block .text-block .whitelist .whitelist-btn span .mtdicon-arrow-right {
  font-size: 20px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
}

.page-top-btutton-list .main-container .text-image-block .image-block img {
  margin-top: 2px;
  margin-left: 8px;
}

.card-body-cover {
  padding: 0px !important;
}

html {
  scroll-behavior: smooth;
}
.center {
  position: relative;
}
.scroll {
  cursor: pointer;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 10;
  -webkit-animation: moving alternate 0.5s infinite;
  animation: moving alternate 0.5s infinite;
}
@-webkit-keyframes moving {
  0% {
    bottom: 30px;
  }
  100% {
    bottom: 20px;
  }
}
@keyframes moving {
  0% {
    bottom: 30px;
  }
  100% {
    bottom: 20px;
  }
}

.help_concat {
  color: rgba(0, 0, 0, 0.84);
}
.help_concat:hover {
  color: #0a70f5;
}

.bottom_icon {
  margin-top: 16px;
}
.bottom_icon:hover {
  opacity: 0.7;
}

.bottom_text {
  color: hsla(0, 0%, 100%, 0.7);
}
.bottom_text:hover {
  color: #fff;
}

@font-face{
  font-family: 'meituantype-Regular';
  src: url('https://s3plus.meituan.net/v1/mss_77a90a9e62374a14a95a15d8334bd502/moa-download-ui/meituantype-Regular.TTF');
}

.info-list-box {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.version-tag {
  font-weight: 500;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #000000;
  letter-spacing: 0;
  line-height: 1.4;
  background: #E6E6E6;
  border-radius: 4px;
  padding: 2px 4px;
  width: fit-content;
  margin-top: 12px;
  -webkit-text-size-adjust: 100%;
}
.version-tag-sub {
  font-weight: 400;
  font-family: PingFangSC-Regular;
  font-size: 10px;
  color: #7F7F7F;
  letter-spacing: 0;
  line-height: 1.6;
  margin-top: 6px;
}
.version-tag-sub a {
  text-decoration: underline;
  color: #166FF7;
}

/* 响应式设计 */@media (max-width: 1440px) { .page-top-btutton-list .main-container .text-image-block .text-block .sub-title { width: auto !important; } } @media (max-width: 1200px) { .moa-page-pc { padding: 0 10px; } } @media (max-width: 992px) { .moa-page-pc { padding: 0 15px; } .page-top-btutton-list .main-container .text-image-block .text-block .title { font-size: 28px; } img[height="280px"] { height: 200px !important; } } @media (max-width: 768px) { .page-top-btutton-list .main-container .text-image-block .text-block .sub-title { font-size: 12px; } } @media (max-width: 576px) { .page-top-btutton-list .main-container .text-image-block .text-block .title { font-size: 20px; } }
</style>


